export const toggleDeliveryDetails = () => {
    const inputs = document.querySelectorAll(
        "#delivery-details .toggle-fields input, #delivery-details .toggle-fields textarea"
    );
    inputs.forEach((input) => {
        input.disabled = !input.disabled;
    });
};

export const setupDeliveryBillingMatch = () => {
    const deliveryBillingMatch = document.getElementById(
        "DeliveryBillingMatch"
    );
    if (deliveryBillingMatch && deliveryBillingMatch.checked) {
        toggleDeliveryDetails();
    }
    if (deliveryBillingMatch) {
        deliveryBillingMatch.addEventListener("change", toggleDeliveryDetails);
    }
};
